const mainTheme = {
  PRIMARY: '#075dff',
  SECONDARY: '#edac01',
  PRIMARY_CTA: '#075dff',
  PRIMARY_CTA_HOVER: '#075dff',
  SECONDARY_CTA: '#edac01',
  DEFAULT: '#231f20',
  BACKGROUND: '#231f20',
  NAV_BACKGROUND: '#231f20',
  BORDER_GRAY: '#231f20',
  DARK_GRAY: '#6d6e71',
  GRAY: '#f5f5f5',
  LIGHT_GRAY: '#D9D9D9',
  LIGHTER_GRAY: '#F2F2F2',
  WHITE_BLUE: 'rgb(233, 237, 245)',
  BLACK: '#02081A',
  ERROR: '#E74C3C',
  GREEN: 'green',
  WHITE: '#FAFAFF',
}

export default mainTheme
